<template>
  <transition name="slide-down">
    <div v-if="!isOnline" class="network-status-bar">
      <i class="el-icon-warning"></i>
      <span>网络连接已断开，请检查您的网络设置</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'NetworkStatus',
  data() {
    return {
      isOnline: navigator.onLine
    }
  },
  mounted() {
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
  },
  beforeDestroy() {
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
  },
  methods: {
    handleOnline() {
      this.isOnline = true;
      this.$message({
        message: '网络连接已恢复',
        type: 'success',
        duration: 2000
      });
    },
    handleOffline() {
      this.isOnline = false;
    }
  }
}
</script>

<style scoped>
.network-status-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: linear-gradient(135deg, #f56c6c 0%, #ff8e53 100%);
  color: white;
  padding: 12px 20px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 2px 12px rgba(245, 108, 108, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.network-status-bar i {
  font-size: 18px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.slide-down-enter-active, .slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
